import { useEffect, useState } from "react";


const CountDown = ({ date }) => {

    const targetTimestamp = new Date(date).getTime();
    const [seconds, setSeconds] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [hours, setHours] = useState(0);
    const [days, setDays] = useState(0);
    function updateCountdown() {
        const currentTimestamp = new Date().getTime();
        const remainingTime = targetTimestamp - currentTimestamp;
        if (remainingTime <= 0) {
            console.log('Countdown has ended!');
        } else {
            const seconds = Math.floor((remainingTime / 1000) % 60);
            setSeconds(seconds);
            const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
            setMinutes(minutes);
            const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
            setHours(hours);
            const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
            setDays(days);
        }
    }

    useEffect(() => {
        updateCountdown()
        setInterval(updateCountdown, 1000);
    }, [])


    return (
        <span className="ml-2">{days}:{hours}:{minutes}:{seconds}</span>
    )
}

export default CountDown;